import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Cart } from '@b2b/features/cart/utilities/cart.model';
import { CartMainComponent } from '@b2b/components/cart/cart-main/cart-main.component';
import { CartListComponent } from '@b2b/components/cart/cart-list/cart-list.component';
import { CartImportComponent } from '@b2b/components/cart/cart-import/cart-import.component';

interface CartState {
  data?: Cart;
  loading: boolean;
  error?: string;
}

export interface CartTemplateContext {
  cart: CartState;
  isEmpty: boolean;
}

@Component({
  selector: 'cart',
  imports: [CommonModule, CartMainComponent, CartListComponent, CartImportComponent],
  templateUrl: './cx-cart-section.component.html',
})
export class CxCartSectionComponent {
  url = this.router.url;

  constructor(private router: Router) {}
}
